<template>
  <v-card class="elevation-2" :disabled="emAnalise(passoParaleloPai)" :key="`${chave}`">
    <v-main class="pa-0 ma-0">
      <v-row class="pa-0 ma-0">
        <v-col class="title pb-0 mb-0" cols="7" :class="{'grey--text text--darken-1': passoParaleloPai.isPassoBloqueado}">
          <span v-html="`${ $tc('label.passo', 1) } ${ passoParaleloPai.sequencia } - `" />{{ tituloPasso }}
        </v-col>
        <v-col class="pt-4 py-0 my-0" cols="5" >
          <v-btn @click.native="reenviarEmailAprovacao()" v-if="passosParalelosPendentes.length > 0" small color="primary">{{ $t('label.reenviar_email_aprovacao') }}</v-btn>
        </v-col>
      </v-row>
      <v-row class="pa-0 ma-0" v-if="!!fluxo.nomeGrupoRepresentacaoConjunto">
        <v-col class="title py-0 my-0">
          <span :class="{'grey--text text--darken-1': passoParaleloPai.isPassoBloqueado}" v-html="`${ fluxo.nomeGrupoRepresentacaoConjunto }`" />
        </v-col>
      </v-row>
      <v-row class="pa-0 ma-0">
        <v-col class="py-0 my-0">
          <span class="warning--text" v-html="`${$t('message.passo_representacao_conjunto')}`" />
        </v-col>
      </v-row>
    </v-main>
    <v-card-text class="historico_body">
      <template v-if="passoParaleloPai.isPassoBloqueado">
        <div class="mt-4 pa-4 d-flex align-center" style="border: 1px dashed #bdbdbd; background-color: #fafafa; border-radius: 8px;">
          <v-avatar color="grey lighten-3" size="48" class="mr-4">
            <v-icon color="grey">warning</v-icon>
          </v-avatar>
          <div>
            <div class="font-weight-bold grey--text text--darken-1" style="font-size: 15px;">
              {{$t('message.aprovacao_nominal_multiplos_aprovadores')}}
            </div>
            <div class="grey--text text--lighten-1" style="font-size: 13px; font-style: italic;">
              {{$t('message.aprovacao_nominal_multiplos_aprovadores_interrupção')}}
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <v-timeline dense class="mx-3 my-1 pt-0 passo-paralelo">
          <v-timeline-item
            v-for="(item, index) in passosParalelosAtivos"
            :color="styles(item.statusPasso)" fill-dot small right
            v-if="exibePasso(item)" :key="`passoParaleloTimeline-${chave}-${index}`" :chave="`passoParaleloTimeline-${chave}-${index}`">

            <template slot="icon">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" style="cursor: default;"></span>
                </template>
                <span>
                  {{$tc(`status_entidade.${item.statusPasso.toLowerCase()}`, 1)}}
                </span>
              </v-tooltip>
            </template>

            <acompanhamento-item
              :key="`passoParaleloItem-${chave}`"
              :chave="`passoParaleloItem-${chave}`"
              :item="item"
              :is-passo-paralelo="true"
              :cliente="fluxo.cliente"
              :entidade="entidade"
              :id-entidade="fluxo.idEntidade">
            </acompanhamento-item>

          </v-timeline-item>

          <v-timeline-item v-if="temPassoInternoBloqueado" color="grey" fill-dot small right>
            <template slot="icon">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" style="cursor: default;"></span>
                </template>
                <span>{{$t('label.interrompido')}}</span>
              </v-tooltip>
            </template>
            <div class="pa-4 d-flex align-center" style="border: 1px dashed #bdbdbd; background-color: #fafafa; border-radius: 8px;">
              <v-avatar color="grey lighten-3" size="48" class="mr-4">
                <v-icon color="grey">warning</v-icon>
              </v-avatar>
              <div>
                <div class="font-weight-bold grey--text text--darken-1" style="font-size: 15px;">
                  {{$t('message.aprovacao_nominal_multiplos_aprovadores')}}
                </div>
                <div class="grey--text text--lighten-1" style="font-size: 13px; font-style: italic;">
                  {{$t('message.aprovacao_nominal_multiplos_aprovadores_interrupção')}}
                </div>
              </div>
            </div>
          </v-timeline-item>

        </v-timeline>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import PopoverLista from '../PopoverLista';
import AcompanhamentoItem from './AcompanhamentoItem';

export default {
  components: {
    PopoverLista,
    AcompanhamentoItem,
  },
  name: 'AcompanhamentoItemPassoParalelo',
  props: {
    passoParaleloPai: {
      type: Object,
      default: () => ({}),
    },
    entidade: String,
    idEntidade: Number,
    fluxo: Object,
    dadosModalAcompanhamento: Object,
    chave: String,
  },
  watch: {
    passoParaleloPai: {
      immediate: true,
      handler(passoParaleloPai) {
        if (passoParaleloPai.usuariosAprovadores) {
          const listaPassosParalelos = passoParaleloPai.usuariosAprovadores.passosParalelos;
          this.passosParalelosPendentes = listaPassosParalelos.filter(
            (passos) => passos.statusPasso === 'AGUARDANDO_APROVACAO' && !passos.isPassoBloqueado,
          );
        }
      },
    },
  },
  data() {
    return {
      resourceFluxo: this.$api.fluxoAprovacao(this.$resource),
      colorPalette: [
        'teal accent-4', // Verde
        'red lighten-1', // Vermelho
        'orange darken-2', // Laranja
        'amber lighten-1', // Amarelo
        'blue-grey lighten-2', // Cinza
        'blue darken-1', // Azul
      ],
      passosParalelosPendentes: [],
    };
  },
  computed: {
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ehContrato() {
      return this.entidade === 'CONTRATO';
    },
    ehRepresentanteLegal() {
      return this.entidade === 'REPRESENTANTE_LEGAL';
    },
    usuarioFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
    passosParalelosAtivos() {
      if (!this.passoParaleloPai || !this.passoParaleloPai.usuariosAprovadores) return [];
      return this.passoParaleloPai.usuariosAprovadores.passosParalelos.filter((p) => !p.isPassoBloqueado);
    },
    temPassoInternoBloqueado() {
      if (!this.passoParaleloPai || !this.passoParaleloPai.usuariosAprovadores) return false;
      return this.passoParaleloPai.usuariosAprovadores.passosParalelos.some((p) => p.isPassoBloqueado);
    },
    tituloPasso() {
      if (this.passoParaleloPai.perfil) {
        return this.passoParaleloPai.perfil;
      }
      if (this.passoParaleloPai.tipoFornecedor === 'REPRESENTANTE_LEGAL') {
        return this.$t('label.representante_legal');
      }
      return this.$t('label.aprovadores');
    },
  },
  methods: {
    aguardandoAprovacao(passo) {
      return passo.statusPasso === 'AGUARDANDO_APROVACAO';
    },
    emAnalise(passo) {
      return !passo || passo.statusPasso === 'EM_ANALISE';
    },
    transferido(passo) {
      return passo.statusPasso === 'TRANSFERIDO';
    },
    exibePasso(passo) {
      return passo.statusPasso !== 'CONDICAO_NAO_ATENDIDA' && passo.statusPasso !== 'TRANSFERIDO';
    },
    isPassoFornecedor(item) {
      return item.tipoFornecedor !== undefined;
    },
    nomePerfilUsuarioAprovador(item) {
      if (item.usuarioAprovador !== undefined) {
        return item.usuarioAprovador.grupo;
      }
      if (item.usuariosAprovadores !== undefined && item.usuariosAprovadores.grupos.length > 0) {
        return item.usuariosAprovadores.grupos[0].nome;
      }
      if (item.tipoFornecedor) {
        return 'Fornecedor';
      }
      return '';
    },
    reenviarEmailAprovacao() {
      const parametros = {
        idPasso: this.passoParaleloPai.id,
        entidade: this.entidade,
      };

      this.resourceFluxo.reenviarEmailAprovacao(parametros, {}).then(() => {
        this.$toast(this.$t('message.email_reenviado'));
      }).catch((err) => {
        this.$error(this, err);
      });
    },
    formatarStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replaceAll('_', ' ');
    },
    styles(status) {
      let colorIndex = 0;
      if (status === 'ENCERRADO') {
        colorIndex = 5;
      } else if (status === 'EM_CADASTRO') {
        colorIndex = 4;
      } else if (status === 'EM_FLUXO') {
        colorIndex = 4;
      } else if (status === 'CANCELADO') {
        colorIndex = 3;
      } else if (status === 'AGUARDANDO_APROVACAO') {
        colorIndex = 2;
      } else if (status === 'REPROVADO') {
        colorIndex = 1;
      } else if (status === 'AGUARDANDO_EXECUCAO_METAS') {
        colorIndex = 6;
      } else if (status === 'AGUARDANDO_APURACAO') {
        colorIndex = 5;
      } else if (status === 'AGUARDANDO_PAGAMENTO') {
        colorIndex = 5;
      } else if (status === 'APURACAO_PREVIA') {
        colorIndex = 4;
      } else if (status === 'EM_ANALISE') {
        colorIndex = 3;
      } else if (status === 'EM_REIVINDICACAO') {
        colorIndex = 2;
      } else {
        colorIndex = 0;
      }

      return this.color || this.colorPalette[colorIndex];
    },
    listaPassosParalelosFiltrada(listaPassosParalelos) {
      if (!this.usuarioFornecedor || !this.ehRepresentanteLegal) {
        return listaPassosParalelos;
      }
      return listaPassosParalelos.slice(0, 1);
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss">
  .passo-paralelo.theme--light.v-timeline::before{
    background: none !important;
  }
</style>
